/* eslint-disable */
import * as registry from '../registry.js'
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ seconds: NonNullable<unknown>, count: NonNullable<unknown> }} Profile_Countdown_SecondsInputs */

const id_profile_countdown_seconds = /** @type {(inputs: Profile_Countdown_SecondsInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("id", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.seconds} detik`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.seconds} detik`);
	return /** @type {LocalizedString} */ ("profile.countdown.seconds");
};

const ms_profile_countdown_seconds = /** @type {(inputs: Profile_Countdown_SecondsInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("ms", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.seconds} saat`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.seconds} saat`);
	return /** @type {LocalizedString} */ ("profile.countdown.seconds");
};

const da_profile_countdown_seconds = /** @type {(inputs: Profile_Countdown_SecondsInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("da", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.seconds} sekund`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.seconds} sekunder`);
	return /** @type {LocalizedString} */ ("profile.countdown.seconds");
};

const de_profile_countdown_seconds = /** @type {(inputs: Profile_Countdown_SecondsInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("de", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.seconds} Sekunde`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.seconds} Sekunden`);
	return /** @type {LocalizedString} */ ("profile.countdown.seconds");
};

const en_us2_profile_countdown_seconds = /** @type {(inputs: Profile_Countdown_SecondsInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("en-US", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.seconds} second`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.seconds} seconds`);
	return /** @type {LocalizedString} */ ("profile.countdown.seconds");
};

const es_es2_profile_countdown_seconds = /** @type {(inputs: Profile_Countdown_SecondsInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("es-ES", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.seconds} segundo`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.seconds} segundos`);
	return /** @type {LocalizedString} */ ("profile.countdown.seconds");
};

const es_mx2_profile_countdown_seconds = /** @type {(inputs: Profile_Countdown_SecondsInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("es-MX", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.seconds} segundo`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.seconds} segundos`);
	return /** @type {LocalizedString} */ ("profile.countdown.seconds");
};

const fil_profile_countdown_seconds = /** @type {(inputs: Profile_Countdown_SecondsInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("fil", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.seconds} segundo`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.seconds} segundo`);
	return /** @type {LocalizedString} */ ("profile.countdown.seconds");
};

const fr_profile_countdown_seconds = /** @type {(inputs: Profile_Countdown_SecondsInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("fr", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.seconds} seconde`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.seconds} secondes`);
	return /** @type {LocalizedString} */ ("profile.countdown.seconds");
};

const it_profile_countdown_seconds = /** @type {(inputs: Profile_Countdown_SecondsInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("it", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.seconds} secondo`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.seconds} secondi`);
	return /** @type {LocalizedString} */ ("profile.countdown.seconds");
};

const hu_profile_countdown_seconds = /** @type {(inputs: Profile_Countdown_SecondsInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("hu", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.seconds} másodperc`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.seconds} másodperc`);
	return /** @type {LocalizedString} */ ("profile.countdown.seconds");
};

const nl_profile_countdown_seconds = /** @type {(inputs: Profile_Countdown_SecondsInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("nl", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.seconds} seconde`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.seconds} seconden`);
	return /** @type {LocalizedString} */ ("profile.countdown.seconds");
};

const no_profile_countdown_seconds = /** @type {(inputs: Profile_Countdown_SecondsInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("no", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.seconds} sekund`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.seconds} sekunder`);
	return /** @type {LocalizedString} */ ("profile.countdown.seconds");
};

const pl_profile_countdown_seconds = /** @type {(inputs: Profile_Countdown_SecondsInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("pl", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.seconds} sekunda`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.seconds} sekund`);
	return /** @type {LocalizedString} */ ("profile.countdown.seconds");
};

const pt_br2_profile_countdown_seconds = /** @type {(inputs: Profile_Countdown_SecondsInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("pt-BR", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.seconds} segundo`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.seconds} segundos`);
	return /** @type {LocalizedString} */ ("profile.countdown.seconds");
};

const pt_profile_countdown_seconds = /** @type {(inputs: Profile_Countdown_SecondsInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("pt", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.seconds} segundo`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.seconds} segundos`);
	return /** @type {LocalizedString} */ ("profile.countdown.seconds");
};

const ro_profile_countdown_seconds = /** @type {(inputs: Profile_Countdown_SecondsInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("ro", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.seconds} secundă`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.seconds} secunde`);
	return /** @type {LocalizedString} */ ("profile.countdown.seconds");
};

const fi_profile_countdown_seconds = /** @type {(inputs: Profile_Countdown_SecondsInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("fi", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.seconds} sekunti`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.seconds} sekuntia`);
	return /** @type {LocalizedString} */ ("profile.countdown.seconds");
};

const sv_profile_countdown_seconds = /** @type {(inputs: Profile_Countdown_SecondsInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("sv", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.seconds} sekund`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.seconds} sekunder`);
	return /** @type {LocalizedString} */ ("profile.countdown.seconds");
};

const vi_profile_countdown_seconds = /** @type {(inputs: Profile_Countdown_SecondsInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("vi", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.seconds} giây`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.seconds} giây`);
	return /** @type {LocalizedString} */ ("profile.countdown.seconds");
};

const tr_profile_countdown_seconds = /** @type {(inputs: Profile_Countdown_SecondsInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("tr", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.seconds} saniye`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.seconds} saniye`);
	return /** @type {LocalizedString} */ ("profile.countdown.seconds");
};

const cs_profile_countdown_seconds = /** @type {(inputs: Profile_Countdown_SecondsInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("cs", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.seconds} sekunda`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.seconds} sekund`);
	return /** @type {LocalizedString} */ ("profile.countdown.seconds");
};

const bg_profile_countdown_seconds = /** @type {(inputs: Profile_Countdown_SecondsInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("bg", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.seconds} секунда`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.seconds} секунди`);
	return /** @type {LocalizedString} */ ("profile.countdown.seconds");
};

const ru_profile_countdown_seconds = /** @type {(inputs: Profile_Countdown_SecondsInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("ru", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.seconds} секунда`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.seconds} секунд(ы)`);
	return /** @type {LocalizedString} */ ("profile.countdown.seconds");
};

const uk_profile_countdown_seconds = /** @type {(inputs: Profile_Countdown_SecondsInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("uk", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.seconds} секунда`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.seconds} секунд`);
	return /** @type {LocalizedString} */ ("profile.countdown.seconds");
};

const ar_profile_countdown_seconds = /** @type {(inputs: Profile_Countdown_SecondsInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("ar", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.seconds} ثانية`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.seconds} ثانية`);
	return /** @type {LocalizedString} */ ("profile.countdown.seconds");
};

const hi_profile_countdown_seconds = /** @type {(inputs: Profile_Countdown_SecondsInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("hi", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.seconds} सेकंड`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.seconds} सेकंड`);
	return /** @type {LocalizedString} */ ("profile.countdown.seconds");
};

const th_profile_countdown_seconds = /** @type {(inputs: Profile_Countdown_SecondsInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("th", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.seconds} วินาที`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.seconds} วินาที`);
	return /** @type {LocalizedString} */ ("profile.countdown.seconds");
};

const ja_profile_countdown_seconds = /** @type {(inputs: Profile_Countdown_SecondsInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("ja", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.seconds} 秒`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.seconds} 秒`);
	return /** @type {LocalizedString} */ ("profile.countdown.seconds");
};

const zh_cn2_profile_countdown_seconds = /** @type {(inputs: Profile_Countdown_SecondsInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("zh-CN", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.seconds} 秒`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.seconds} 秒`);
	return /** @type {LocalizedString} */ ("profile.countdown.seconds");
};

const zh_hant1_profile_countdown_seconds = /** @type {(inputs: Profile_Countdown_SecondsInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("zh-Hant", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.seconds} 秒`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.seconds} 秒`);
	return /** @type {LocalizedString} */ ("profile.countdown.seconds");
};

const ko_profile_countdown_seconds = /** @type {(inputs: Profile_Countdown_SecondsInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("ko", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.seconds}초`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.seconds}초`);
	return /** @type {LocalizedString} */ ("profile.countdown.seconds");
};

/**
* | countPlural | output |
* | --- | --- |
* | "one" | "{seconds} second" |
* | "other" | "{seconds} seconds" |
*
* @param {Profile_Countdown_SecondsInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const profile_countdown_seconds = /** @type {((inputs: Profile_Countdown_SecondsInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Countdown_SecondsInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_profile_countdown_seconds(inputs)
	if (locale === "ms") return ms_profile_countdown_seconds(inputs)
	if (locale === "da") return da_profile_countdown_seconds(inputs)
	if (locale === "de") return de_profile_countdown_seconds(inputs)
	if (locale === "en-US") return en_us2_profile_countdown_seconds(inputs)
	if (locale === "es-ES") return es_es2_profile_countdown_seconds(inputs)
	if (locale === "es-MX") return es_mx2_profile_countdown_seconds(inputs)
	if (locale === "fil") return fil_profile_countdown_seconds(inputs)
	if (locale === "fr") return fr_profile_countdown_seconds(inputs)
	if (locale === "it") return it_profile_countdown_seconds(inputs)
	if (locale === "hu") return hu_profile_countdown_seconds(inputs)
	if (locale === "nl") return nl_profile_countdown_seconds(inputs)
	if (locale === "no") return no_profile_countdown_seconds(inputs)
	if (locale === "pl") return pl_profile_countdown_seconds(inputs)
	if (locale === "pt-BR") return pt_br2_profile_countdown_seconds(inputs)
	if (locale === "pt") return pt_profile_countdown_seconds(inputs)
	if (locale === "ro") return ro_profile_countdown_seconds(inputs)
	if (locale === "fi") return fi_profile_countdown_seconds(inputs)
	if (locale === "sv") return sv_profile_countdown_seconds(inputs)
	if (locale === "vi") return vi_profile_countdown_seconds(inputs)
	if (locale === "tr") return tr_profile_countdown_seconds(inputs)
	if (locale === "cs") return cs_profile_countdown_seconds(inputs)
	if (locale === "bg") return bg_profile_countdown_seconds(inputs)
	if (locale === "ru") return ru_profile_countdown_seconds(inputs)
	if (locale === "uk") return uk_profile_countdown_seconds(inputs)
	if (locale === "ar") return ar_profile_countdown_seconds(inputs)
	if (locale === "hi") return hi_profile_countdown_seconds(inputs)
	if (locale === "th") return th_profile_countdown_seconds(inputs)
	if (locale === "ja") return ja_profile_countdown_seconds(inputs)
	if (locale === "zh-CN") return zh_cn2_profile_countdown_seconds(inputs)
	if (locale === "zh-Hant") return zh_hant1_profile_countdown_seconds(inputs)
	return ko_profile_countdown_seconds(inputs)
});
export { profile_countdown_seconds as "profile.countdown.seconds" }